import {fromEvent, merge, timer} from "rxjs";
import {take, tap} from "rxjs/operators";
import Vimeo from '@vimeo/player';


export const VimeoInit = (iframe) =>{

    //let iframe =

    //let cover = jQuery('.video-cover');
    console.log(iframe);
    if(!iframe || iframe.length == 0){
        return;
    }
    //let container = iframe.parent().parent().parent();
    let player = new Vimeo(iframe.get(0), {
        // responsive: true
        autoplay:true,
        muted: true,
        background: true,
        //controls: false,
        loop: true
    });
    // player.addCuePoint(3,'started');

    let playClick = false;
    let playRequested = false;
    player.play();
    /*fromEvent(container, 'click').pipe(
        // tap(e => player.)
        tap(e=> {
            player.play();
            playClick = true;
            container.addClass('buffering');
        })
    ).subscribe();
*/
   /* fromEvent(player, 'play').pipe(
        tap(e => console.log('PLAY',e)),
        tap(e => iframe.addClass('show'))
    ).subscribe();*/

    merge(fromEvent(player, 'play'), timer(4000)).pipe(
        take(1),
        tap(e => console.log('PLAY',e)),
        tap(e => iframe.addClass('show'))
    ).subscribe();


    //let playStarted = new Subject();

/*
    fromEvent(player, 'cuepoint').pipe(
        tap(e => {
            console.log('CUEPOINT', e, playRequested, playClick);
            //cover.addClass('hide');
            // container.removeClass('buffering');
            //player.pause()

        }),
        //delay(3000),
        //tap( e => player.play())

    ).subscribe();*/
}
